import { useMutation, useQuery } from "@apollo/client";
import { Chip, CircularProgress } from "@material-ui/core";
import React, { useContext, useState } from "react";
import SnackbarContext from "../../../Context/SnackbarContext";
import Empty from "../../UI/Empty/Empty";
import Error from "../../UI/Error/Error";

import "./Category.scss";
import CategoryEdit from "./CategoryEdit/CategoryEdit";
import { GetCategories, ToggleCategory } from "./CategoryQuery";

const Category: React.FC = () => {
	const {
		data: categories,
		error,
		loading,
		refetch,
	} = useQuery(GetCategories);
	const [editSeason, setEditSeason] = useState<any>(null);
	const [seasonModal, setSeasonModal] = useState<boolean>(false);

	if (error) {
		return <Error error={error} />;
	}

	const callRefetch = () => {
		console.log("Calling Refetch");
		refetch();
	};

	return (
		<div className="container-main">
			<CategoryEdit
				isOpen={seasonModal}
				setModal={setSeasonModal}
				refetch={callRefetch}
				setEditData={setEditSeason}
				editData={editSeason}
			/>

			<div className="season__box">
				<div className="season__main">
					<div className="season__header">
						<p className="title">Categories</p>
						<button
							type="button"
							onClick={() => {
								setSeasonModal(true);
							}}
						>
							+Add Category
						</button>
					</div>
					<CategoryTitle />
					{loading ? (
						<div className="spinner-container">
							<CircularProgress size={40} thickness={4} />
						</div>
					) : categories.categories.length > 0 ? (
						categories.categories.map((element: any) => {
							return (
								<CategoryItem
									element={element}
									refetch={callRefetch}
									key={element.id}
									onClickEdit={() => {
										setEditSeason(element);
										setSeasonModal(true);
									}}
								/>
							);
						})
					) : (
						<Empty />
					)}
				</div>
			</div>
		</div>
	);
};

export default Category;

const CategoryTitle: React.FC = () => {
	return (
		<div className="subCategory__table">
			<p className="season__table-title">ID</p>
			<p className="season__table-title">Name</p>
			<p className="season__table-title">Category-Type</p>
		</div>
	);
};

interface SeasonItemProps {
	element: any;
	onClickEdit: () => void;
	refetch: () => void;
}

const CategoryItem: React.FC<SeasonItemProps> = (props: SeasonItemProps) => {
	const { element, onClickEdit, refetch } = props;
	const { setSnackbar, setMessage } = useContext(SnackbarContext);

	const [toggleCategory] = useMutation(ToggleCategory);
	const [loading, setLoading] = useState(false);

	const categoryTypeList = element.categoriesCategoryTypes.map(
		(e) => e.categoryType
	);

	const onToggle = () => {
		console.log(element.id + " " + element.isDeleted);
		setLoading(true);
		toggleCategory({
			variables: {
				categoryId: element.id,
				isDeleted: !element.isDeleted,
			},
		})
			.then(({ data }) => {
				setSnackbar(true);
				setMessage("Category updated Successfully");
				setLoading(false);
				refetch();
			})
			.catch((error) => {
				setSnackbar(true);
				setMessage(error.message);
			});
	};

	return (
		<div className="subCategory__table">
			<p className="season__table-item">{element.id}</p>
			<p className="season__table-item">{element.name}</p>
			<div className="season__table-item">
				{categoryTypeList && categoryTypeList.length > 0 && (
					<div className="subCategory__table-chip-container">
						{categoryTypeList.map((chipData) => {
							return (
								<div
									style={{
										margin: "2px 2px",
									}}
								>
									<Chip
										label={chipData.name}
										key={chipData.id}
										size="small"
									></Chip>
								</div>
							);
						})}
					</div>
				)}
			</div>

			<div className="season__actions">
				<button className="btn-list" onClick={onClickEdit}>
					Edit
				</button>

				{loading ? (
					<div
						style={{ width: "4rem" }}
						className="spinner-container"
					>
						<CircularProgress size={20} thickness={3} />
					</div>
				) : (
					<button
						className="btn-list"
						onClick={() => {
							onToggle();
						}}
					>
						{element.isDeleted ? "Enable" : "Disable"}
					</button>
				)}
			</div>
		</div>
	);
};
